/* eslint-disable import/prefer-default-export */
import lod_ from "lodash";
import notificationActions from "redux/actions/notificationActions";
import { markNotificationAsRead } from "redux/reducers/notificationsReducer";
import cockpitActions from "../redux/actions/cockpitActions";

/**
 * Mark a notification as read
 * @param {string} notificationId - ID of the notification to mark as read
 * @param {function} dispatch - Redux dispatch function
 */
const handleMarkAsRead = (notificationId, dispatch) => {
	if (lod_.isNil(notificationId) === true) {
		return;
	}

	// Optimistic update
	const readAt = new Date().toISOString();
	dispatch(markNotificationAsRead({ id: notificationId, readAt }));

	// API call
	dispatch(
		notificationActions.markAsRead(
			notificationId,
			() => {},
			() => {}
		)
	);
};

/**
 * Handle notification click action
 * @param {Object} notification - The notification object
 * @param {function} dispatch - Redux dispatch function
 */
export const handleNotificationClick = (notification, dispatch) => {
	if (lod_.isNil(notification) === true) {
		return;
	}

	// Mark as read if not already read
	if (notification.read !== true) {
		handleMarkAsRead(notification.id, dispatch);
	}

	// Handle different types of actions based on notification.action
	switch (notification.action) {
		case "mention": {
			if (
				lod_.isNil(notification?.payload?.assistantID) ||
				lod_.isNil(notification?.payload?.fID)
			) {
				break;
			}
			dispatch(
				cockpitActions.selectConversation({
					header: {
						assistantID: notification.payload.assistantID,
						fID: notification.payload?.fID
					}
				})
			);
			break;
		}
		default: {
			break;
		}
	}
};
